<template>
  <hr />
</template>

<style lang="scss" scoped>
hr {
  border-color: $primary-100;
  margin-bottom: 1.25rem;
}
</style>
